import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { Droppable } from 'react-beautiful-dnd'

import ChartSlot from './components/ChartSlot'
import Typography from '../../../UniformComponents/Typography'
import BaseSize from './BaseSize'

const TwoByTwoLayout = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div style={{ display: 'flex', gap: 5, height: 'calc(100% - 120px)', flexWrap: 'wrap' }}>
            {[0, 1, 2, 3].map((i) => (
                <Droppable key={i} droppableId={`slide-${i}`}>
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="pp-chart-slots"
                            style={{ width: 'calc(50% - 5px)', height: '50%' }}
                        >
                            <ChartSlot
                                store={store}
                                key={`${store.activeSlide.id}-${i}`}
                                position={i}
                            />
                        </div>
                    )}
                </Droppable>
            ))}
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            {[0, 1, 2, 3].map((i) => (
                <div style={{ display: 'flex', justifyContent: 'space-between', width: 'calc(50% - 5px)' }}>
                    <Typography type="tiny">{store.activeSlide.question.has(i) ? store.activeSlide.question.get(i).questionLongText :  i18n.t('question')}</Typography>
                    <BaseSize store={store} position={i} />
                </div>
            ))}
        </div>
    </div>
))

export default TwoByTwoLayout
